import script from "./ReturnToMobileApp.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnToMobileApp.vue?vue&type=script&setup=true&lang=js"

import "./ReturnToMobileApp.vue?vue&type=style&index=0&id=2ca9a563&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ca9a563"]])

export default __exports__